import styled from 'styled-components';
import { Segment, Flex } from 'nallian-shared-ui/lib/components';

export const List = styled.ul`
  padding: 0;
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: flex-start;

  && strong {
    text-align: left;
    width: 8rem;
  }
`;

export const LegalDocumentContainer = styled(Segment)`
  height: ${props => props.height || '40vh'};
  width: 100%;
  overflow: auto;
  &.ui.segment.small {
    padding: 0;
  }
`;

export const OrganisationFormFlexWrapper = styled(Flex)`
  && .ui.grid > .column:not(.row) {
    padding-top: 0;
  }

  && .ui.grid > .column:not(.row),
  .ui.grid > .row > .column {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`;
